import { ActionTree, ActionContext } from 'vuex';
import { ProfileState, Transaction, DetailInfo } from '@/modules/profile/store/types';
import { RootState } from '@/store/types';
import {
    GET_USER_TRANSACTIONS,
    GET_USER_TRANSACTIONS_SUCCESS,
    GET_USER_TRANSACTIONS_ERROR,
    GET_USER_INFO,
    GET_USER_INFO_SUCCESS,
    GET_USER_INFO_ERROR,
} from '@/modules/profile/store/constants';
import profileService from '@/modules/profile/store/service';

const actions = {
    async [GET_USER_TRANSACTIONS](store: ActionContext<ProfileState, RootState>) {
        store.commit(GET_USER_TRANSACTIONS);
        try {
            const payload: Transaction[] = await profileService.fakeGetTransactions();
            store.commit(GET_USER_TRANSACTIONS_SUCCESS, payload);
        } catch (e) {
            store.commit(GET_USER_TRANSACTIONS_ERROR);
        }
    },
    async [GET_USER_INFO](store: ActionContext<ProfileState, RootState>) {
        store.commit(GET_USER_INFO);
        try {
            const payload: DetailInfo = await profileService.fakeGetUserInfo();
            store.commit(GET_USER_INFO_SUCCESS, payload);
        } catch (e) {
            store.commit(GET_USER_INFO_ERROR);
        }
    },
} as ActionTree<ProfileState, any>;

export default actions;
